<template>
  <div>
    <SSubHeader :pageName="getPageName" :backButton="isEditPage" />
    <div class="header-spacer--standard"></div>
    <ItemReviewForm @button="saveItem" @cancel="cancel" >
      <div class="container">
        <div class="row justify-content-between mb-3">
          <div class="md-layout md-gutter col-12 whole-page">
            <div
              class="md-layout-item left-section image-layout"
            >
            <div class="dropboxes">
              <ReviewTradeType ref="type" />
              <ReviewItemCategory ref="category" />
              <ReviewItemCondition ref="condition" />
            </div>
            <div class="image-box">
              <ItemPostImage ref="image" />
            </div>

            </div>
            <div class="md-layout-item">
              <ReviewItemPrice ref="payment" />
              <ReviewDescriptionBooks v-if="itemCategory === 8" ref="description" />
              <ReviewDescription v-else ref="description" />
              <CheckItemAtMyGroups ref="group" data-cy="ir" :isEditPage="isEditPage" />
            </div>
          </div>
        </div>

      </div>
    </ItemReviewForm>
    <LoadingSpinner position="absolute" v-if="isFetching" />
    <Footer/>
    <Modal
      id="upload"
      buttonName="OK"
      ref="modal"
      title="Item post"
      data-cy="mdItemReview"
      :material-button="true"
      @button="closeModal"
    >
      <footer v-if="uploaded" class="h5" data-cy="niResponse">
        {{ postItemResponse.result }}
      </footer>
      <div v-else class="spinner-border text-primary" role="status"></div>
    </Modal>
  </div>
</template>

<script>
import SSubHeader from "@/material-components/organisms/SSubHeader";
import ItemReviewForm from "@/components/organisms/ItemReviewForm";
import ItemPostImage from "@/components/molecules/ItemPostImage";
import CheckItemAtMyGroups from "@/components/molecules/CheckItemAtMyGroups";
import Modal from "@/components/atoms/Modal";
import { mapGetters, mapActions } from "vuex";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import PointsHelperVue from "../../mixins/PointsHelper.vue";
import Footer from "@/templates/Footer";

//new components bellow
import ReviewTradeType from "@/material-components/molecules/ReviewTradeType";
import ReviewDescription from "@/material-components/molecules/ReviewDescription";
import ReviewDescriptionBooks from "@/material-components/molecules/ReviewDescriptionBooks";
import ReviewItemCategory from "@/material-components/molecules/ReviewItemCategory";
import ReviewItemCondition from "@/material-components/molecules/ReviewItemCondition";
import ReviewItemPrice from "@/material-components/molecules/ReviewItemPrice";

export default {
  name: "ItemReview",
  mixins: [ItemHelperVue, UserHelperVue, PointsHelperVue],
  components: {
    SSubHeader,
    ItemReviewForm,
    ItemPostImage,
    Modal,
    CheckItemAtMyGroups,
    LoadingSpinner,
    ReviewTradeType,
    ReviewDescription,
    ReviewDescriptionBooks,
    ReviewItemCategory,
    ReviewItemCondition,
    ReviewItemPrice,
    Footer,
  },
  data() {
    return {
      uploaded: false,
      willEdit: false,
      edit_item: {},
      isFetching: null,
    };
  },
  computed: {
    ...mapGetters({
      itemPostFeaturedImage: "getNewItemImage",
      itemTitle: "getNewItemTitle",
      itemDescription: "getNewItemDescription",
      itemType: "getNewItemType",
      itemPaymentType: "getNewItemPaymentType",
      itemPaymentCash: "getNewItemPaymentCash",
      itemPaymentPoints: "getNewItemPaymentPoints",
      itemCategory: "getNewItemCategory",
      itemCondition: "getNewItemCondition",
      newItem: "getNewItem",
      postItemResponse: "getPostItemResponse",
    }),
    getPageName() {
      return this.willEdit ? "Item edit" : "Item review";
    },
    isEditPage() {
      return this.willEdit;
    },
    filledFields() {
      if (
        this.itemTitle &&
        this.itemDescription &&
        this.itemType &&
        this.itemPaymentType.length > 0 &&
        this.itemCategory &&
        (this.imageFile || this.newItem.isbn_image_link) &&
        this.itemCondition
      ) {
        return !((this.itemPaymentType.includes("points") &&
            !this.itemPaymentPoints) ||
          (this.itemPaymentType.includes("money") && !this.itemPaymentCash));
      }
      return false;
    },
  },
  methods: {
    ...mapActions(["postItem","setNewItemAuthor", "setNewItemSynopsis", "setNewItemIsbn"]),
    async saveItem() {
      $("#upload").modal("show");
      this.storeUpdates();
      if (this.$route.query.edit) {
        await this.updateItem({
          item: { ...this.newItem },
          item_id: this.edit_item.id,
        });
      } else {
        await this.postItem({ ...this.newItem });
      }
      this.fetchMyPoints();
      this.fetchMyPointSum();

      if (Object.keys(this.postItemResponse).length > 0) {
        this.uploaded = true;
        this.setNewItemAuthor("");
        this.setNewItemSynopsis("");
        this.setNewItemIsbn("");
        sessionStorage.clear();
      }
    },
    cancel() {
      this.setNewItemAuthor("");
      this.setNewItemSynopsis("");
      this.setNewItemIsbn("");
      sessionStorage.clear();
      this.$router.push({ name: "MyPostArea" });
    },
    async storeUpdates() {
      this.$refs.description.storeDescription();
      this.$refs.type.storeType();
      this.$refs.payment.storePaymentType();
      this.$refs.payment.storePaymentValues();
      this.$refs.category.storeCategory();
      this.$refs.condition.storeCondition();
      this.$refs.group.storeAvailableOnlyToMyGroups();
    },
    closeModal() {
      if (this.edit_item.id) {
        this.$route.path !== `/s-app/item-details/${this.edit_item.id}` &&
          this.$router.push(`/s-app/item-details/${this.edit_item.id}`);
      } else {
        this.$route.path !==
          `/s-app/item-details/${this.postItemResponse.itemId}` &&
          this.$router.push(
            `/s-app/item-details/${this.postItemResponse.itemId}`
          );
      }
      this.$refs.modal.closeModal();
    },
    async setEditItemPaymentType() {
      let paymentArray = [];
      if (this.edit_item.cash === 0 && this.edit_item.points === 0) {
        this.edit_item.payment_type = "free";
      } else if (this.edit_item.cash === 0 && this.edit_item.points > 0) {
        paymentArray.push("points");
        this.edit_item.payment_type = paymentArray;
      } else if (this.edit_item.points === 0 && this.edit_item.cash > 0) {
        paymentArray.push("money");
        this.edit_item.payment_type = paymentArray;
      } else {
        this.edit_item.payment_type = ["points", "money"];
      }
    },
    async editItem() {
      if (this.$route.query.edit) {
        this.edit_item = {};
        this.resetNewItem();
        let obj = { id: this.$route.query.item_id };
        let imagePath = this.getItemImagePath(obj);
        await this.fetchItemProfile(this.$route.query.item_id);
        this.edit_item = this.itemProfile;
        const result = await this.urltoFile(imagePath);
        this.edit_item.image_file = result;
        const b64 = await this.toBase64(result);
        this.edit_item.image = b64;
        this.edit_item.status = 0;
        await this.setEditItemPaymentType();
        await this.setItem({ item: this.edit_item });
      }
    },
    addKeydownEvent() {
    window.addEventListener("keydown", (e) => {
        if (
          e.key == "Escape" &&
          $("#upload").is(":visible") &&
          this.postItemResponse.result === "Post successful!"
        ) {
          this.closeModal();
        }
        if (e.key == "Escape" && $("#new-item").is(":visible")) {
          this.setNewItemStep({ step: 0 });
        }
      });
    },
    addPasteEvent() {
      window.addEventListener(
          "paste",
          (event) => {
            if (!$("#create-group").is(":visible")) {
              if (this.$refs.image !== undefined) {
                this.$refs.image.retrieveImageFromClipboardAsBlob(
                  event,
                  (imageBlob) => {
                    if (imageBlob !== undefined) {
                      this.$refs.image.loadImage(imageBlob);
                    }
                  }
                );
              }
            }
          },
          false
        );
    },
    addClickEvent() {
      document.addEventListener("click", (event) => {
          if (
            !$(event.target).closest(".modal-content").length &&
            $("#upload").is(":visible") &&
            this.postItemResponse.result === "Post successful!"
          ) {
            this.closeModal();
          }
          if (
            !$(event.target).closest(".modal-content").length &&
            !$(event.target).closest(".search-autocomplete").length &&
            $("#new-item").is(":visible")
          )
            this.setNewItemStep({ step: 0 });
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.editItem();
    });
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.postItemResponse &&
      (this.postItemResponse.result === "Post successful!" ||
        this.postItemResponse.result === "Item updated!")
    ) {
      this.resetNewItem();
    }
    next();
  },
  
  created() {
    this.isFetching = true;
    if (this.$route.query.edit === undefined) {
      this.getStoredItemSession();
    } else this.willEdit = true;
    setTimeout(() => {
      this.addKeydownEvent();
      this.addPasteEvent();
      this.addClickEvent();      
      this.isFetching = false;
    }, 5000);
  },
};
</script>

<style lang="scss" scoped>
.left-section {
  min-width: 35%;
  max-width: 35%;
  flex: 0 1 35%;
}
.dropboxes {
  margin-bottom: 50px;
}
@media screen and (min-width: 1024px) {
  .image-layout {
    padding: 3rem 2rem 0rem 4rem !important;
    padding: 0rem 2rem 0rem 4rem !important;
  }
}


@media  screen and (min-width: 1199px) and (max-width: 1280px) {
  .image-layout {
    min-width: 35% !important;
    max-width: 35% !important;
  }
}

@media  screen and (min-width: 1024px) and (max-width: 1399px) {
  .image-layout {
    padding-left: 1rem !important;
  }
}
@media  screen and (max-width: 1023px) {
  .whole-page {
    display: flex;
    flex-direction: column;
  }
  .left-section {
    display: flex;
    flex-direction: column;
    max-width: unset;
    width: 100%;
  }
  .image-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
  }
}

</style>
